export default (savingBalance, socialFundBalance) => {
  if (
    parseInt(savingBalance, 10) === 0 &&
    parseInt(socialFundBalance, 10) === 0
  )
    return true;
  return false;
};
